<template>
  <v-container></v-container>
</template>
<script>
  export default {
    props: ['token'],
    computed: {
      authenticated () {
        return this.$store.getters.authenticated
      }
    },
    mounted () {
      this.authenticateWithToken()
    },
    methods: {
      authenticateWithToken () {
        var credentials = {
          LoginType: 4,
          Token: `${this.token}`,
          redirectTo: '/'
        }
        this.$store.dispatch('authenticateUser', credentials)
      }
    }
  }
</script>
